export enum HistoryRewardType {
    'CONTEST' =' CONTEST',
    'CATALOG' = 'CATALOG',
    'CATALOG_LOYALTY_COLLECTION' = 'CATALOG_LOYALTY_COLLECTION',
    'CATALOG_DIGITAL_WALLET' = 'CATALOG_DIGITAL_WALLET',
    'ALL' = 'ALL',
} ;